"use client";

import { AnimatePresence, m } from "motion/react";
import { useRef } from "react";
import { Button } from "@/components/ui/button";
import { SPRING } from "@/lib/motion";
import { cn } from "@/lib/utils";

const COOLDOWN_MS = 350;

interface SpeedToggleButtonProps {
  className?: string;
  isFast: boolean;
  labels?: { fast: string; slow: string };
  onToggle: () => void;
}

export function SpeedToggleButton({
  isFast,
  onToggle,
  labels = { fast: "Fast", slow: "Slow" },
  className,
}: SpeedToggleButtonProps) {
  const lastToggleRef = useRef(0);

  const handleToggle = () => {
    const now = Date.now();
    if (now - lastToggleRef.current < COOLDOWN_MS) {
      return;
    }
    lastToggleRef.current = now;
    onToggle();
  };

  return (
    <Button
      className={cn(
        "relative min-w-16 gap-1 overflow-hidden will-change-transform hover-hover:hover:not-disabled:bg-gray-200",
        className
      )}
      onClick={handleToggle}
      size="sm"
      type="button"
      variant="secondary"
    >
      <AnimatePresence initial={false} mode="popLayout">
        <m.span
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          initial={{ opacity: 0, y: -40 }}
          key={isFast ? "fast" : "slow"}
          transition={SPRING}
        >
          {isFast ? labels.fast : labels.slow}
        </m.span>
      </AnimatePresence>
    </Button>
  );
}
